import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbSpPlatforms } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular/ui/select-box';

@Component({
  selector: 'app-sp-platform-picker',
  templateUrl: './sp-platform-picker.component.html',
  styleUrls: ['./sp-platform-picker.component.scss'],
})
export class SpPlatformPickerComponent {

    @Input()
    public selectedItem: string;

    @Input()
    public readonly: boolean = false;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public platforms: any[] = new Array<any>();
    public loading: boolean = true;

    public constructor() {
        for (const spplatform in OcbSpPlatforms) {
            if (isNaN(Number(spplatform))) {
                this.platforms.push({ name: spplatform, id: OcbSpPlatforms[spplatform] });
            }
        }
        this.loading = false;
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event.id);
    }
}
